import { render } from "./ProductDetail.vue?vue&type=template&id=5d1e5472&scoped=true"
import script from "./ProductDetail.vue?vue&type=script&lang=js"
export * from "./ProductDetail.vue?vue&type=script&lang=js"

import "./ProductDetail.vue?vue&type=style&index=0&id=5d1e5472&scoped=true&lang=css"

import exportComponent from "E:\\ismailDosyalar\\gifSites2\\gifSites\\2022\\gesas\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d1e5472"]])

export default __exports__